import * as Yup from "yup";

const SportSchema = Yup.object().shape({
  id: Yup.string().trim().required("Required"),
  name: Yup.string().trim().required("Required"),
  displayOrder: Yup.string().required("Required"),
});

export default SportSchema;
